import styled from "styled-components";

/* The installed rc-select nests the selection in an extra
   .rc-select-selection-wrap element the ADS Select styles don't know about,
   which leaves the selected value top-aligned. Re-center it, scoped to the
   members filter row. */
export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--ads-v2-spaces-3);

  .ads-v2-select .rc-select-selection-wrap {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  /* block container + align-content keeps text-overflow working
     (it is inert on flex containers) */
  .ads-v2-select .rc-select-selection-wrap .rc-select-selection-item,
  .ads-v2-select .rc-select-selection-wrap .rc-select-selection-placeholder {
    position: absolute;
    inset: 0;
    align-content: center;
    box-sizing: border-box;
    padding-right: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
